import { useAppSelector } from '../../redux/hooks'
import { getIsLoading } from '../../redux/reducers/appSettings'
import {
    CompanyProductPickActions,
    CompanyProductPickState,
    productsCompany,
    ProductsCompany,
} from '@raskrask-dk/bookingflow-state-machine'
import { ReactElement } from 'react'
import { CompanyProductPickTemplate } from '.'
import { useBFSMValue } from '../../services/hooks/useBFSMValues'
import { useBFSM } from '../../contexts/bfsmContext'

const CompanyProductPickPage = (): ReactElement => {
    const [BFSM] = useBFSM()

    const [, setProductType] = useBFSMValue<
        CompanyProductPickState,
        CompanyProductPickActions.PickProduct,
        'productType'
    >('productType', CompanyProductPickActions.PickProduct)

    ////////////
    // "Global"
    const isLoading = useAppSelector((state) => getIsLoading(state))

    ////////////
    // Company Product Pick
    const onProductClick = (product: ProductsCompany) => {
        setProductType(product)
        BFSM.doAction(CompanyProductPickActions.Next, undefined)
    }

    return (
        <CompanyProductPickTemplate
            productsHandler={{
                onClick: onProductClick,
                available: [...productsCompany],
            }}
            isLoading={isLoading}
        />
    )
}

export default CompanyProductPickPage
